module.exports = __webpack_public_path__ + "static/media/TEAM.f1181487.svg";